import React from 'react';
import NameListRow from './NameListRow';
import { Table } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
const tableHeadings = ['employee_name_number', 'half_year_required', 'bda_check_if_yes', 'fulltime', 'digital_record', 'share_of_working_time', 'rel_agreed_annual_working_hrs', '', '', ''];
const NameList = _ref => {
  let {
    data,
    setData,
    selectedProject,
    emptyNameLists,
    removeEmptyRow
  } = _ref;
  const {
    t
  } = useTranslation();
  const tableHeadingRow = tableHeadings.map((heading, i) => {
    return /*#__PURE__*/React.createElement("th", {
      key: 'th' + i
    }, t(heading));
  });
  const tableRows = data.map(currentData => {
    return /*#__PURE__*/React.createElement(NameListRow, {
      rowData: currentData,
      key: currentData.id,
      data: data,
      setData: setData,
      selectedProject: selectedProject
    });
  });
  const emptyRows = emptyNameLists.map(emptyNameList => {
    return /*#__PURE__*/React.createElement(NameListRow, {
      key: 'createRowNameList' + emptyNameList.emptyRowId,
      emptyRowId: emptyNameList.emptyRowId,
      data: data,
      setData: setData,
      selectedProject: selectedProject,
      removeEmptyRow: removeEmptyRow,
      rowData: emptyNameList
    });
  });
  return /*#__PURE__*/React.createElement(Table, {
    responsive: "md"
  }, /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement("tr", null, tableHeadingRow)), /*#__PURE__*/React.createElement("tbody", null, tableRows, emptyRows));
};
export default NameList;